var _circle, _path, _rect, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaxWithMaximumConvenience(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F3EEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.696V14a1 1 0 011-1h12a1 1 0 011 1v20a1 1 0 01-1 1h-9.706",
    stroke: "#8178C0",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19,
    width: 10,
    height: 16,
    rx: 1,
    stroke: "#8178C0",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31v2",
    stroke: "#8178C0",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNGM0VFRkUiLz4KPHBhdGggZD0iTTE5IDE5LjY5NTdWMTRDMTkgMTMuNDQ3NyAxOS40NDc3IDEzIDIwIDEzSDMyQzMyLjU1MjMgMTMgMzMgMTMuNDQ3NyAzMyAxNFYzNEMzMyAzNC41NTIzIDMyLjU1MjMgMzUgMzIgMzVIMjIuMjk0MSIgc3Ryb2tlPSIjODE3OEMwIiBzdHJva2Utd2lkdGg9IjIiLz4KPHJlY3QgeD0iMTUiIHk9IjE5IiB3aWR0aD0iMTAiIGhlaWdodD0iMTYiIHJ4PSIxIiBzdHJva2U9IiM4MTc4QzAiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMjAgMzFWMzMiIHN0cm9rZT0iIzgxNzhDMCIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";
export { SvgFaxWithMaximumConvenience as ReactComponent };